import React, { Component } from 'react'
import { Icon } from '@driftt/tide-core-legacy'
import './style.styl'


class Sidesheet extends Component {

  constructor(props) {
    super(props)

    this.state = {
      closed: true
    }
  }

  componentDidMount() {
    // animate open
    setTimeout(() => {
      this.setState({ closed: false })
    }, 0)
  }

  closeBar = () => {
    const closeBarDelay = () => setTimeout(this.props.onClose, 600)

    this.setState({
      closed: true
    }, closeBarDelay)
  }

  renderModal = () => {

    const closedClass = this.state.closed ? 'closed' : ''

    return (
      <div className={`sidesheet ${closedClass}`}>
        <div className="sidesheet-click-area" onClick={this.closeBar}/>
        {this.renderContent()}
      </div>
    )
  }


  renderContent = () => {
    const hasTitle = !!this.props.title

    return (
      <div className="sidesheet-content">
        {hasTitle && <header className="sidesheet-header">
          <div className="sidesheet-header-title">
            {this.props.title}
          </div>
          <div className="sidesheet-close" onClick={this.closeBar}>
            <Icon name="close" width={15}/>
          </div>
        </header>}
        {this.props.children}
      </div>)
  }


  render() {
    return this.props.isModal ? this.renderModal() : this.renderContent()
  }
}


export default Sidesheet



// WEBPACK FOOTER //
// ./src/scripts/components/Sidesheet/index.js